import Vue from 'vue';

export const getParagraph = (function() {
  let requestPromise = null;
  return async function() {
    try {
      if (!requestPromise) {
        requestPromise = Vue.prototype.httpPost('/nlp/case/get/label/relation/data/paragraph', {});
      }
      const result = await requestPromise;
      return result.data.hits.map(item => ({
        key: item._source.field_name,
        value: item._source.chinese_name,
        parentId: item._source.parentId,
        groups: item._source.groups
      }));
    } catch (err) {
      requestPromise = null;
      throw Error(err);
    }
  };
})();

export const getDrugSetting = (function() {
  let requestPromise = null;
  return async function() {
    try {
      if (!requestPromise) {
        requestPromise = Vue.prototype.httpGet('admin/drugSetting');
      }
      const { data } = await requestPromise;
      return data;
    } catch (err) {
      requestPromise = null;
      throw Error(err);
    }
  };
})();

export const getLawTreeMap = (function() {
  let promise = null;
  return async function() {
    if (promise) {
      return await promise;
    }
    promise = new Promise(async resolve => {
      try {
        const { data } = await Vue.prototype.httpGet('nlp/law/tree/map');
        const list = data.map(item => item._source);
        resolve(list);
      } catch (err) {
        console.error(err);
        promise = null;
        resolve([]);
      }
    });
    return await promise;
  };
})();


// WEBPACK FOOTER //
// ./src/service/labelRelation.js